import {RouteConfig} from 'vue-router';
import QuestFlagView from '@/views/questionnaire/flag/Flag.vue';
import QuestFlagInfoView from '@/views/questionnaire/flag/Info.vue';
import QuestView from '@/views/questionnaire/Index.vue';

export const QuestionnaireRoutes: Array<RouteConfig | any> = [
  {
    path: '/questionnaire',
    name: 'questionnaire',
    component: QuestView,
    children: [
      {
        path: 'flag',
        name: 'flag',
        component: QuestFlagView
      },
      {
        path: 'flag-info/:text',
        name: 'flag-info',
        component: QuestFlagInfoView
      }
    ],
  },

];
